import tableApiCredentials from './tableApiCredentials';
export default {
  title: 'Tokens',
  attributeName: "tokens",
  getURL: 'key/tokens',
  idAttribute: 'id',
  idUpdate: true,
  createURL: 'key/tokens/new',
  removeURL: 'key/tokens/delete',
  updateURL : 'key/tokens/edit',
  sessionParams: [],
  noArea: true,
  tableConfig: tableApiCredentials,
  autoUpdate: false,
};

